import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet } from "../utils/api_service";
const initialState = {
  addionalActivity: [],
};
let URL = endpoints.additionalActivity;
const addionalActivitySlice = createSlice({
  name: "addionalActivity",
  initialState,
  reducers: {
    addionalActivitySuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        addionalActivity: row,
      };
    },

    resetState: (state = cloneDeep(initialState), action) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const { addionalActivitySuccess, resetState } =
  addionalActivitySlice.actions;

export default addionalActivitySlice.reducer;

export const getAddionalActivity = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + "/get-all",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((addionalActivityObj, index) => {
          let addionalActivityData = {
            index: index + 1,
            id: addionalActivityObj.id === null ? "" : addionalActivityObj.id,
            name:
              addionalActivityObj.name === null ? "" : addionalActivityObj.name,
            description:
              addionalActivityObj.description === null
                ? ""
                : addionalActivityObj.description,
            beatType:
              addionalActivityObj.beatType === null
                ? ""
                : addionalActivityObj.beatType === 0
                  ? "Working"
                  : addionalActivityObj.beatType === 1
                    ? "Non-Working"
                    : "",
            startAction:
              addionalActivityObj.startAction === null
                ? ""
                : addionalActivityObj.startAction === 1
                  ? "Yes"
                  : addionalActivityObj.startAction === 0
                    ? "No"
                    : "",
            stockStakeHolderTypeIds:
              addionalActivityObj.stockStakeHolderTypeIds === null
                ? ""
                : addionalActivityObj.stockStakeHolderTypeIds,
            stockStakeHolderTypeNames:
              addionalActivityObj.stockStakeHolderTypeNames === null
                ? ""
                : addionalActivityObj.stockStakeHolderTypeNames,
            isActive:
              addionalActivityObj.isActive === null
                ? ""
                : addionalActivityObj.isActive,
          };
          return addionalActivityData;
        });
        dispatch(addionalActivitySuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};
